import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "page-mj"
};
const _hoisted_2 = {
  class: "inner custom-scroll"
};
const _hoisted_3 = {
  class: "mj-box"
};
const _hoisted_4 = {
  class: "param-line pt"
};
const _hoisted_5 = {
  class: "param-line pt"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "text"
};
const _hoisted_8 = {
  class: "param-line",
  style: {
    "padding-top": "10px"
  }
};
const _hoisted_9 = {
  class: "form-item-inner flex-row items-center"
};
const _hoisted_10 = {
  class: "param-line pt"
};
const _hoisted_11 = {
  class: "param-line pt"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "text"
};
const _hoisted_14 = {
  class: "param-line"
};
const _hoisted_15 = {
  class: "form-item-inner"
};
const _hoisted_16 = {
  class: "param-line"
};
const _hoisted_17 = {
  class: "form-item-inner"
};
const _hoisted_18 = {
  class: "param-line",
  style: {
    "padding-top": "10px"
  }
};
const _hoisted_19 = {
  class: "form-item-inner"
};
const _hoisted_20 = {
  class: "param-line"
};
const _hoisted_21 = {
  class: "form-item-inner"
};
const _hoisted_22 = {
  class: "param-line"
};
const _hoisted_23 = {
  class: "form-item-inner"
};
const _hoisted_24 = {
  class: "task-list-box pl-6 pr-6 pb-4 h-dvh"
};
const _hoisted_25 = {
  class: "extra-params"
};
const _hoisted_26 = {
  class: "prompt-box"
};
const _hoisted_27 = {
  class: "param-line pt"
};
const _hoisted_28 = {
  class: "flex-row justify-between items-center"
};
const _hoisted_29 = {
  class: "flex-row justify-start items-center"
};
const _hoisted_30 = {
  class: "param-line pt",
  style: {
    "position": "relative"
  }
};
const _hoisted_31 = {
  class: "param-line pt"
};
const _hoisted_32 = {
  class: "flex-row justify-between items-center"
};
const _hoisted_33 = {
  class: "flex-row justify-start items-center"
};
const _hoisted_34 = {
  class: "param-line pt"
};
const _hoisted_35 = {
  class: "param-line"
};
const _hoisted_36 = {
  class: "img-inline"
};
const _hoisted_37 = {
  class: "img-list-box"
};
const _hoisted_38 = {
  class: "param-line",
  style: {
    "padding-top": "10px"
  }
};
const _hoisted_39 = {
  class: "form-item-inner"
};
const _hoisted_40 = {
  class: "prompt-box"
};
const _hoisted_41 = {
  class: "param-line pt"
};
const _hoisted_42 = {
  class: "flex-row justify-between items-center"
};
const _hoisted_43 = {
  class: "flex-row justify-start items-center"
};
const _hoisted_44 = {
  class: "param-line pt"
};
const _hoisted_45 = {
  class: "param-line pt"
};
const _hoisted_46 = {
  class: "flex-row justify-between items-center"
};
const _hoisted_47 = {
  class: "flex-row justify-start items-center"
};
const _hoisted_48 = {
  class: "param-line pt"
};
const _hoisted_49 = {
  class: "img-inline"
};
const _hoisted_50 = {
  class: "img-list-box"
};
const _hoisted_51 = {
  class: "img-inline"
};
const _hoisted_52 = {
  class: "img-list-box"
};
const _hoisted_53 = {
  class: "param-line"
};
const _hoisted_54 = {
  class: "param-line"
};
const _hoisted_55 = {
  class: "param-line",
  style: {
    "padding-top": "10px"
  }
};
const _hoisted_56 = {
  class: "form-item-inner"
};
const _hoisted_57 = {
  class: "prompt-box"
};
const _hoisted_58 = {
  class: "param-line pt"
};
const _hoisted_59 = {
  class: "flex-row justify-between items-center"
};
const _hoisted_60 = {
  class: "flex-row justify-start items-center"
};
const _hoisted_61 = {
  class: "param-line pt"
};
const _hoisted_62 = {
  class: "param-line pt"
};
const _hoisted_63 = {
  class: "flex-row justify-between items-center"
};
const _hoisted_64 = {
  class: "flex-row justify-start items-center"
};
const _hoisted_65 = {
  class: "param-line pt"
};
const _hoisted_66 = {
  class: "submit-btn"
};
const _hoisted_67 = {
  class: "job-list-box"
};
const _hoisted_68 = {
  class: "finish-job-list"
};
const _hoisted_69 = {
  key: 0
};
const _hoisted_70 = {
  class: "job-item"
};
const _hoisted_71 = {
  class: "image-slot"
};
const _hoisted_72 = {
  class: "image-slot"
};
const _hoisted_73 = {
  class: "err-msg-container"
};
const _hoisted_74 = {
  class: "opt"
};
const _hoisted_75 = {
  key: 3,
  class: "opt"
};
const _hoisted_76 = {
  class: "opt-line"
};
const _hoisted_77 = ["onClick"];
const _hoisted_78 = ["onClick"];
const _hoisted_79 = ["onClick"];
const _hoisted_80 = ["onClick"];
const _hoisted_81 = {
  class: "show-prompt"
};
const _hoisted_82 = {
  class: "mj-list-item-prompt"
};
const _hoisted_83 = {
  class: "opt-line"
};
const _hoisted_84 = ["onClick"];
const _hoisted_85 = ["onClick"];
const _hoisted_86 = ["onClick"];
const _hoisted_87 = ["onClick"];
const _hoisted_88 = {
  key: 4,
  class: "remove"
};
import { nextTick, onMounted, onUnmounted, ref } from "vue";
import { ChromeFilled, Delete, DocumentCopy, InfoFilled, Picture, Plus, UploadFilled } from "@element-plus/icons-vue";
import nodata from "@/assets/img/no-data.png";
import Compressor from "compressorjs";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
import Clipboard from "clipboard";
import { checkSession, getClientId, getSystemInfo } from "@/store/cache";
import { useRouter } from "vue-router";
import { getSessionId } from "@/store/session";
import { copyObj, removeArrayItem } from "@/utils/libs";
import { useSharedStore } from "@/store/sharedata";
import TaskList from "@/components/TaskList.vue";
import BackTop from "@/components/BackTop.vue";
import { showMessageError } from "@/utils/dialog";
export default {
  __name: 'ImageMj',
  setup(__props) {
    const listBoxHeight = ref(0);
    const paramBoxHeight = ref(0);
    const loading = ref(true);
    const colWidth = ref(220);
    const previewURL = ref("");
    const store = useSharedStore();
    const resizeElement = function () {
      // listBoxHeight.value = window.innerHeight - 80;
      listBoxHeight.value = window.innerHeight - 30;
      // paramBoxHeight.value = window.innerHeight - 160;
      paramBoxHeight.value = window.innerHeight - 110;
    };
    resizeElement();
    window.onresize = () => {
      resizeElement();
    };
    const rates = [{
      css: "square",
      value: "1:1",
      text: "1:1",
      img: "/images/mj/rate_1_1.png"
    }, {
      css: "size1-2",
      value: "1:2",
      text: "1:2",
      img: "/images/mj/rate_1_2.png"
    }, {
      css: "size2-1",
      value: "2:1",
      text: "2:1",
      img: "/images/mj/rate_2_1.png"
    }, {
      css: "size2-3",
      value: "2:3",
      text: "2:3",
      img: "/images/mj/rate_3_4.png"
    }, {
      css: "size3-2",
      value: "3:2",
      text: "3:2",
      img: "/images/mj/rate_4_3.png"
    }, {
      css: "size3-4",
      value: "3:4",
      text: "3:4",
      img: "/images/mj/rate_3_4.png"
    }, {
      css: "size4-3",
      value: "4:3",
      text: "4:3",
      img: "/images/mj/rate_4_3.png"
    }, {
      css: "size16-9",
      value: "16:9",
      text: "16:9",
      img: "/images/mj/rate_16_9.png"
    }, {
      css: "size9-16",
      value: "9:16",
      text: "9:16",
      img: "/images/mj/rate_9_16.png"
    }];
    const models = [{
      text: "写实模式MJ-6.1",
      value: " --v 6.1",
      img: "/images/mj/mj-v6.png"
    }, {
      text: "优质模式MJ-6.0",
      value: " --v 6",
      img: "/images/mj/mj-v5.2.png"
    }, {
      text: "优质模式MJ-5.2",
      value: " --v 5.2",
      img: "/images/mj/mj-v5.1.jpg"
    }, {
      text: "虚幻模式MJ-5.1",
      value: " --v 5.1",
      img: "/images/mj/mj-v5.jpg"
    }, {
      text: "真实模式MJ-4",
      value: " --v 4",
      img: "/images/mj/mj-v4.jpg"
    }, {
      text: "动漫风-niji4",
      value: " --niji 4",
      img: "/images/mj/nj4.jpg"
    }, {
      text: "动漫风-niji5",
      value: " --niji 5",
      img: "/images/mj/mj-niji.png"
    }, {
      text: "动漫风-niji5 可爱",
      value: " --niji 5 --style cute",
      img: "/images/mj/nj1.jpg"
    }, {
      text: "动漫风-niji5 风景",
      value: " --niji 5 --style scenic",
      img: "/images/mj/nj2.jpg"
    }, {
      text: "动漫风-niji6",
      value: " --niji 6",
      img: "/images/mj/nj3.jpg"
    }];
    const options = [{
      value: 0,
      label: "默认"
    }, {
      value: 0.25,
      label: "普通"
    }, {
      value: 0.5,
      label: "清晰"
    }, {
      value: 1,
      label: "高清"
    }];
    const router = useRouter();
    const initParams = {
      client_id: getClientId(),
      task_type: "image",
      rate: rates[0].value,
      model: models[0].value,
      chaos: 0,
      stylize: 0,
      seed: 0,
      img_arr: [],
      raw: false,
      iw: 0,
      prompt: router.currentRoute.value.params["prompt"] ?? "",
      neg_prompt: "",
      tile: false,
      quality: 0,
      cref: "",
      sref: "",
      cw: 0
    };
    const params = ref(copyObj(initParams));
    const imgList = ref([]);
    const activeName = ref("txt2img");
    const runningJobs = ref([]);
    const finishedJobs = ref([]);
    const power = ref(0);
    const userId = ref(0);
    const isLogin = ref(false);
    const clipboard = ref(null);
    onMounted(() => {
      initData();
      clipboard.value = new Clipboard(".copy-prompt-mj");
      clipboard.value.on("success", () => {
        ElMessage.success("复制成功！");
      });
      clipboard.value.on("error", () => {
        ElMessage.error("复制失败！");
      });
      store.addMessageHandler("mj", data => {
        // 丢弃无关消息
        if (data.channel !== "mj" || data.clientId !== getClientId()) {
          return;
        }
        if (data.body === "FINISH" || data.body === "FAIL") {
          page.value = 0;
          isOver.value = false;
          fetchFinishJobs();
        }
        nextTick(() => fetchRunningJobs());
      });
    });
    onUnmounted(() => {
      clipboard.value.destroy();
      store.removeMessageHandler("mj");
    });

    // 初始化数据
    const initData = () => {
      checkSession().then(user => {
        power.value = user["power"];
        userId.value = user.id;
        isLogin.value = true;
        page.value = 0;
        fetchRunningJobs();
        fetchFinishJobs();
      }).catch(() => {});
    };
    const mjPower = ref(1);
    const mjActionPower = ref(1);
    getSystemInfo().then(res => {
      mjPower.value = res.data["mj_power"];
      mjActionPower.value = res.data["mj_action_power"];
    }).catch(e => {
      ElMessage.error("获取系统配置失败：" + e.message);
    });

    // 获取运行中的任务
    const fetchRunningJobs = () => {
      if (!isLogin.value) {
        return;
      }
      httpGet(`/api/mj/jobs?finish=false`).then(res => {
        const jobs = res.data.items;
        const _jobs = [];
        for (let i = 0; i < jobs.length; i++) {
          if (jobs[i].progress === 101) {
            ElNotification({
              title: "任务执行失败",
              dangerouslyUseHTMLString: true,
              message: `任务ID：${jobs[i]["task_id"]}<br />原因：${jobs[i]["err_msg"]}`,
              type: "error",
              duration: 0
            });
            if (jobs[i].type === "image") {
              power.value += mjPower.value;
            } else {
              power.value += mjActionPower.value;
            }
          }
          _jobs.push(jobs[i]);
        }
        runningJobs.value = _jobs;
      }).catch(e => {
        ElMessage.error("获取任务失败：" + e.message);
      });
    };
    const page = ref(0);
    const pageSize = ref(15);
    const isOver = ref(false);
    const fetchFinishJobs = () => {
      if (!isLogin.value || isOver.value) {
        return;
      }
      loading.value = true;
      page.value = page.value + 1;
      // 获取已完成的任务
      httpGet(`/api/mj/jobs?finish=true&page=${page.value}&page_size=${pageSize.value}`).then(res => {
        const jobs = res.data.items;
        for (let i = 0; i < jobs.length; i++) {
          if (jobs[i]["img_url"] !== "") {
            if (jobs[i].type === "upscale" || jobs[i].type === "swapFace") {
              jobs[i]["thumb_url"] = jobs[i]["img_url"] + "?imageView2/1/w/480/h/600/q/75";
            } else {
              jobs[i]["thumb_url"] = jobs[i]["img_url"] + "?imageView2/1/w/480/h/480/q/75";
            }
          } else {
            jobs[i]["thumb_url"] = "/images/img-placeholder.jpg";
          }
          if (jobs[i].type !== "upscale" && jobs[i].progress === 100) {
            jobs[i]["can_opt"] = true;
          }
        }
        if (jobs.length < pageSize.value) {
          isOver.value = true;
        }
        if (page.value === 1) {
          finishedJobs.value = jobs;
        } else {
          finishedJobs.value = finishedJobs.value.concat(jobs);
        }
        loading.value = false;
      }).catch(e => {
        ElMessage.error("获取任务失败：" + e.message);
      });
    };

    // 切换图片比例
    const changeRate = item => {
      params.value.rate = item.value;
    };
    // 切换模型
    const changeModel = item => {
      params.value.model = item.value;
    };
    const imgKey = ref("");
    const beforeUpload = key => {
      imgKey.value = key;
    };

    // 图片上传
    const uploadImg = file => {
      if (!isLogin.value) {
        store.setShowLoginDialog(true);
        return;
      }

      // 压缩图片并上传
      new Compressor(file.file, {
        quality: 0.6,
        success(result) {
          const formData = new FormData();
          formData.append("file", result, result.name);
          // 执行上传操作
          httpPost("/upload", formData).then(res => {
            if (imgKey.value === "") {
              imgList.value.push(res.data.url);
            } else {
              // 单张图片上传
              params.value[imgKey.value] = res.data.url;
              imgKey.value = "";
            }
            ElMessage.success("上传成功");
          }).catch(e => {
            ElMessage.error("上传失败:" + e.message);
          });
        },
        error(err) {
          console.log(err.message);
        }
      });
    };

    // 创建绘图任务
    const promptRef = ref(null);
    const generate = () => {
      if (!isLogin.value) {
        store.setShowLoginDialog(true);
        return;
      }
      if (params.value.prompt === "" && params.value.task_type === "image") {
        promptRef.value.focus();
        return ElMessage.error("请输入绘画提示词！");
      }
      if (params.value.model.indexOf("niji") !== -1 && params.value.raw) {
        return ElMessage.error("动漫模型不允许启用原始模式");
      }
      if (imgList.value.length !== 2 && params.value.task_type === "swapFace") {
        return ElMessage.error("换脸操作需要上传两张图片");
      }
      params.value.session_id = getSessionId();
      params.value.img_arr = imgList.value;
      httpPost("/mj/image", params.value).then(() => {
        ElMessage.success("绘画任务推送成功，请耐心等待任务执行...");
        power.value -= mjPower.value;
        fetchRunningJobs();
      }).catch(e => {
        ElMessage.error("任务推送失败：" + e.message);
      });
    };

    // 图片放大任务
    const upscale = (index, item) => {
      send("/mj/upscale", index, item);
    };

    // 图片变换任务
    const variation = (index, item) => {
      send("/mj/variation", index, item);
    };
    const send = (url, index, item) => {
      httpPost(url, {
        index: index,
        client_id: getClientId(),
        channel_id: item.channel_id,
        message_id: item.message_id,
        message_hash: item.hash,
        session_id: getSessionId(),
        prompt: item.prompt
      }).then(() => {
        ElMessage.success("任务推送成功，请耐心等待任务执行...");
        power.value -= mjActionPower.value;
        fetchRunningJobs();
      }).catch(e => {
        ElMessage.error("任务推送失败：" + e.message);
      });
    };
    const removeImage = item => {
      ElMessageBox.confirm("此操作将会删除任务和图片，继续操作码?", "删除提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        httpGet("/mj/remove", {
          id: item.id,
          user_id: item.user_id
        }).then(() => {
          ElMessage.success("任务删除成功");
          page.value = 0;
          isOver.value = false;
          fetchFinishJobs();
        }).catch(e => {
          ElMessage.error("任务删除失败：" + e.message);
        });
      }).catch(() => {});
    };

    // 发布图片到作品墙
    const publishImage = (item, action) => {
      let text = "图片发布";
      if (action === false) {
        text = "取消发布";
      }
      httpGet("/mj/publish", {
        id: item.id,
        action: action,
        user_id: item.user_id
      }).then(() => {
        ElMessage.success(text + "成功");
        item.publish = action;
        page.value = 0;
        isOver.value = false;
        item.publish = action;
      }).catch(e => {
        ElMessage.error(text + "失败：" + e.message);
      });
    };
    const previewImg = item => {
      previewURL.value = item.img_url;
    };

    // 切换菜单
    const tabChange = tab => {
      if (tab === "txt2img" || tab === "img2img" || tab === "cref") {
        params.value.task_type = "image";
      } else {
        params.value.task_type = tab;
      }
    };

    // 删除已上传图片
    const removeUploadImage = url => {
      imgList.value = removeArrayItem(imgList.value, url);
    };
    const isGenerating = ref(false);
    const generatePrompt = () => {
      if (params.value.prompt === "") {
        return showMessageError("请输入原始提示词");
      }
      isGenerating.value = true;
      httpPost("/prompt/image", {
        prompt: params.value.prompt
      }).then(res => {
        params.value.prompt = res.data;
        isGenerating.value = false;
      }).catch(e => {
        showMessageError("生成提示词失败：" + e.message);
        isGenerating.value = false;
      });
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_slider = _resolveComponent("el-slider");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_badge = _resolveComponent("el-badge");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_v3_waterfall = _resolveComponent("v3-waterfall");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_image_viewer = _resolveComponent("el-image-viewer");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[23] || (_cache[23] = _createElementVNode("h2", null, "MidJourney 创作中心", -1)), _createElementVNode("div", {
        class: "mj-params",
        style: _normalizeStyle({
          height: paramBoxHeight.value + 'px'
        })
      }, [_createVNode(_component_el_form, {
        model: params.value,
        "label-width": "80px",
        "label-position": "left"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_cache[21] || (_cache[21] = _createElementVNode("span", null, "图片比例：", -1)), _createVNode(_component_el_tooltip, {
          content: "生成图片的尺寸比例",
          placement: "right"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
            _: 1
          })]),
          _: 1
        })]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_row, {
          gutter: 10
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(rates, item => {
            return _createVNode(_component_el_col, {
              span: 8,
              key: item.value
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: _normalizeClass(["flex-col items-center", item.value === params.value.rate ? 'grid-content active' : 'grid-content']),
                onClick: $event => changeRate(item)
              }, [_createVNode(_component_el_image, {
                class: "icon",
                src: item.img,
                fit: "cover"
              }, null, 8, ["src"]), _createElementVNode("div", _hoisted_7, _toDisplayString(item.text), 1)], 10, _hoisted_6)]),
              _: 2
            }, 1024);
          }), 64))]),
          _: 1
        })]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_form_item, {
          label: "图片画质"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_select, {
            modelValue: params.value.quality,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.value.quality = $event),
            placeholder: "请选择",
            style: {
              "width": "150px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, item => {
              return _createVNode(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
            content: "生成的图片质量，质量越好出图越慢",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_10, [_cache[22] || (_cache[22] = _createElementVNode("span", null, "模型选择：", -1)), _createVNode(_component_el_tooltip, {
          content: "MJ: 偏真实通用模型 <br/>NIJI: 偏动漫风格、适用于二次元模型",
          "raw-content": "",
          placement: "right"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
            _: 1
          })]),
          _: 1
        })]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_row, {
          gutter: 10
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(models, item => {
            return _createVNode(_component_el_col, {
              span: 12,
              key: item.value
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: _normalizeClass(item.value === params.value.model ? 'model active' : 'model'),
                onClick: $event => changeModel(item)
              }, [_createVNode(_component_el_image, {
                src: item.img,
                fit: "cover"
              }, null, 8, ["src"]), _createElementVNode("div", _hoisted_13, _toDisplayString(item.text), 1)], 10, _hoisted_12)]),
              _: 2
            }, 1024);
          }), 64))]),
          _: 1
        })]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_form_item, {
          label: "重复平铺"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_switch, {
            modelValue: params.value.tile,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => params.value.tile = $event),
            "inactive-color": "#464649"
          }, null, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
            content: "重复：--tile，参数释义：生成可用作重复平铺的图像，以创建无缝图案。",
            "raw-content": "",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_form_item, {
          label: "原始模式"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_switch, {
            modelValue: params.value.raw,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => params.value.raw = $event),
            "inactive-color": "#464649"
          }, null, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
            content: "启用新的RAW模式，呈现的人物写实感更加逼真，人物细节、光源、流畅度也更加接近原始作品。<br/> 同时也意味着您需要添加更长的提示。",
            "raw-content": "",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_form_item, {
          label: "创意度"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_slider, {
            modelValue: params.value.chaos,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => params.value.chaos = $event),
            modelModifiers: {
              number: true
            },
            max: 100,
            step: 1,
            style: {
              "width": "180px"
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
            content: "参数用法：--chaos 或--c，取值范围: 0-100 <br/> 取值越高结果越发散，反之则稳定收敛<br /> 默认值0最为精准稳定",
            "raw-content": "",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_form_item, {
          label: "风格化"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createVNode(_component_el_slider, {
            modelValue: params.value.stylize,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => params.value.stylize = $event),
            modelModifiers: {
              number: true
            },
            min: 0,
            max: 1000,
            step: 1,
            style: {
              "width": "180px"
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
            content: "风格化：--stylize 或 --s，范围 1-1000，默认值100 <br/>高取值会产生非常艺术化但与提示关联性较低的图像",
            "raw-content": "",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_form_item, {
          label: "随机种子"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_createVNode(_component_el_input, {
            modelValue: params.value.seed,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => params.value.seed = $event),
            modelModifiers: {
              number: true
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
            content: "随机种子：--seed，默认值0表示随机产生 <br/>使用相同的种子参数和描述将产生相似的图像",
            "raw-content": "",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })])]),
        _: 1
      }, 8, ["model"])], 4)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", {
        class: "task-list-inner",
        style: _normalizeStyle({
          height: listBoxHeight.value + 'px'
        })
      }, [_createElementVNode("div", _hoisted_25, [_createVNode(_component_el_form, null, {
        default: _withCtx(() => [_createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => activeName.value = $event),
          class: "title-tabs",
          onTabChange: tabChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            label: "文生图",
            name: "txt2img"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_cache[24] || (_cache[24] = _createElementVNode("span", null, "提示词：", -1)), _createVNode(_component_el_tooltip, {
              content: "输入你想要的内容，用逗号分割",
              placement: "right"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                _: 1
              })]),
              _: 1
            })])])]), _createElementVNode("div", _hoisted_30, [_withDirectives(_createVNode(_component_el_input, {
              modelValue: params.value.prompt,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => params.value.prompt = $event),
              autosize: {
                minRows: 4,
                maxRows: 6
              },
              type: "textarea",
              ref_key: "promptRef",
              ref: promptRef,
              placeholder: "请在此输入绘画提示词，您也可以点击下面的提示词助手生成绘画提示词"
            }, null, 8, ["modelValue"]), [[_directive_loading, isGenerating.value]])]), _createVNode(_component_el_row, {
              class: "text-info"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                class: "generate-btn",
                size: "small",
                onClick: generatePrompt,
                color: "#5865f2",
                disabled: isGenerating.value
              }, {
                default: _withCtx(() => _cache[25] || (_cache[25] = [_createElementVNode("i", {
                  class: "iconfont icon-chuangzuo"
                }, null, -1), _createElementVNode("span", null, "生成专业绘画指令", -1)])),
                _: 1
              }, 8, ["disabled"])]),
              _: 1
            }), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_cache[26] || (_cache[26] = _createElementVNode("span", null, "不希望出现的内容：（可选）", -1)), _createVNode(_component_el_tooltip, {
              content: "不想出现在图片上的元素(例如：树，建筑)",
              placement: "right"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                _: 1
              })]),
              _: 1
            })])])]), _createElementVNode("div", _hoisted_34, [_createVNode(_component_el_input, {
              modelValue: params.value.neg_prompt,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => params.value.neg_prompt = $event),
              autosize: {
                minRows: 4,
                maxRows: 6
              },
              type: "textarea",
              ref_key: "promptRef",
              ref: promptRef,
              placeholder: "请在此输入你不希望出现在图片上的内容，系统会自动翻译中文提示词"
            }, null, 8, ["modelValue"])])])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "图生图",
            name: "img2img"
          }, {
            default: _withCtx(() => [_cache[30] || (_cache[30] = _createElementVNode("div", {
              class: "text"
            }, "图生图：以某张图片为底稿参考来创作绘画，生成类似风格或类型图像，支持 PNG 和 JPG 格式图片；", -1)), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgList.value, imgURL => {
              return _openBlock(), _createElementBlock("div", {
                class: "img-item",
                key: imgURL
              }, [_createVNode(_component_el_image, {
                src: imgURL,
                fit: "cover"
              }, null, 8, ["src"]), _createVNode(_component_el_button, {
                type: "danger",
                icon: _unref(Delete),
                onClick: $event => removeUploadImage(imgURL),
                circle: ""
              }, null, 8, ["icon", "onClick"])]);
            }), 128))]), _createVNode(_component_el_upload, {
              class: "img-uploader",
              "auto-upload": true,
              "show-file-list": false,
              "http-request": uploadImg
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, {
                class: "uploader-icon"
              }, {
                default: _withCtx(() => [_createVNode(_unref(Plus))]),
                _: 1
              })]),
              _: 1
            })])]), _createElementVNode("div", _hoisted_38, [_createVNode(_component_el_form_item, {
              label: "参考权重："
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_39, [_createVNode(_component_el_slider, {
                modelValue: params.value.iw,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => params.value.iw = $event),
                modelModifiers: {
                  number: true
                },
                max: 1,
                step: 0.01,
                style: {
                  "width": "180px"
                }
              }, null, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
                content: "使用图像权重参数--iw来调整图像 URL 与文本的重要性 <br/>权重较高时意味着图像提示将对完成的作业产生更大的影响",
                "raw-content": "",
                placement: "right"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                  _: 1
                })]),
                _: 1
              })])]),
              _: 1
            })]), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_cache[27] || (_cache[27] = _createElementVNode("span", null, "提示词：", -1)), _createVNode(_component_el_tooltip, {
              content: "输入你想要的内容，用逗号分割",
              placement: "right"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                _: 1
              })]),
              _: 1
            })])])]), _createElementVNode("div", _hoisted_44, [_withDirectives(_createVNode(_component_el_input, {
              modelValue: params.value.prompt,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => params.value.prompt = $event),
              autosize: {
                minRows: 4,
                maxRows: 6
              },
              type: "textarea",
              ref_key: "promptRef",
              ref: promptRef,
              placeholder: "请在此输入绘画提示词，系统会自动翻译中文提示词，高手请直接输入英文提示词"
            }, null, 8, ["modelValue"]), [[_directive_loading, isGenerating.value]])]), _createVNode(_component_el_row, {
              class: "text-info"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                class: "generate-btn",
                size: "small",
                onClick: generatePrompt,
                color: "#5865f2",
                disabled: isGenerating.value
              }, {
                default: _withCtx(() => _cache[28] || (_cache[28] = [_createElementVNode("i", {
                  class: "iconfont icon-chuangzuo"
                }, null, -1), _createElementVNode("span", null, "生成专业绘画指令", -1)])),
                _: 1
              }, 8, ["disabled"])]),
              _: 1
            }), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_cache[29] || (_cache[29] = _createElementVNode("span", null, "不希望出现的内容：（可选）", -1)), _createVNode(_component_el_tooltip, {
              content: "不想出现在图片上的元素(例如：树，建筑)",
              placement: "right"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                _: 1
              })]),
              _: 1
            })])])]), _createElementVNode("div", _hoisted_48, [_createVNode(_component_el_input, {
              modelValue: params.value.neg_prompt,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => params.value.neg_prompt = $event),
              autosize: {
                minRows: 4,
                maxRows: 6
              },
              type: "textarea",
              ref_key: "promptRef",
              ref: promptRef,
              placeholder: "请在此输入你不希望出现在图片上的内容，系统会自动翻译中文提示词"
            }, null, 8, ["modelValue"])])])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "融图",
            name: "blend"
          }, {
            default: _withCtx(() => [_cache[31] || (_cache[31] = _createElementVNode("div", {
              class: "text"
            }, "请上传两张以上的图片，最多不超过五张，超过五张图片请使用图生图功能", -1)), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgList.value, imgURL => {
              return _openBlock(), _createElementBlock("div", {
                class: "img-item",
                key: imgURL
              }, [_createVNode(_component_el_image, {
                src: imgURL,
                fit: "cover"
              }, null, 8, ["src"]), _createVNode(_component_el_button, {
                type: "danger",
                icon: _unref(Delete),
                onClick: $event => removeUploadImage(imgURL),
                circle: ""
              }, null, 8, ["icon", "onClick"])]);
            }), 128))]), _createVNode(_component_el_upload, {
              class: "img-uploader",
              "auto-upload": true,
              "show-file-list": false,
              "http-request": uploadImg
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, {
                class: "uploader-icon"
              }, {
                default: _withCtx(() => [_createVNode(_unref(Plus))]),
                _: 1
              })]),
              _: 1
            })])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "换脸",
            name: "swapFace"
          }, {
            default: _withCtx(() => [_cache[32] || (_cache[32] = _createElementVNode("div", {
              class: "text"
            }, "请上传两张有脸部的图片，用左边图片的脸替换右边图片的脸", -1)), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgList.value, imgURL => {
              return _openBlock(), _createElementBlock("div", {
                class: "img-item",
                key: imgURL
              }, [_createVNode(_component_el_image, {
                src: imgURL,
                fit: "cover"
              }, null, 8, ["src"]), _createVNode(_component_el_button, {
                type: "danger",
                icon: _unref(Delete),
                onClick: $event => removeUploadImage(imgURL),
                circle: ""
              }, null, 8, ["icon", "onClick"])]);
            }), 128))]), _createVNode(_component_el_upload, {
              class: "img-uploader",
              "auto-upload": true,
              "show-file-list": false,
              "http-request": uploadImg
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, {
                class: "uploader-icon"
              }, {
                default: _withCtx(() => [_createVNode(_unref(Plus))]),
                _: 1
              })]),
              _: 1
            })])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            name: "cref"
          }, {
            label: _withCtx(() => [_createVNode(_component_el_badge, {
              value: "New"
            }, {
              default: _withCtx(() => _cache[33] || (_cache[33] = [_createElementVNode("span", null, "一致性", -1)])),
              _: 1
            })]),
            default: _withCtx(() => [_cache[36] || (_cache[36] = _createElementVNode("div", {
              class: "text"
            }, "注意：只有于 niji6 和 v6 模型支持一致性功能，如果选择其他模型此功能将会生成失败。", -1)), _createElementVNode("div", _hoisted_53, [_createVNode(_component_el_form_item, {
              label: "角色一致性：",
              prop: "cref"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: params.value.cref,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => params.value.cref = $event),
                placeholder: "请输入图片URL或者上传图片",
                style: {
                  "--el-input-focus-border-color": "#b0a0f8",
                  "max-width": "500px",
                  "width": "100%"
                },
                size: "small"
              }, {
                append: _withCtx(() => [_createVNode(_component_el_upload, {
                  "auto-upload": true,
                  "show-file-list": false,
                  onClick: _cache[11] || (_cache[11] = $event => beforeUpload('cref')),
                  "http-request": uploadImg
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, {
                    class: "uploader-icon"
                  }, {
                    default: _withCtx(() => [_createVNode(_unref(UploadFilled))]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]), _createElementVNode("div", _hoisted_54, [_createVNode(_component_el_form_item, {
              label: "风格一致性：",
              prop: "sref"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: params.value.sref,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => params.value.sref = $event),
                placeholder: "请输入图片URL或者上传图片",
                style: {
                  "--el-input-focus-border-color": "#b0a0f8",
                  "max-width": "500px",
                  "width": "100%"
                },
                size: "small"
              }, {
                append: _withCtx(() => [_createVNode(_component_el_upload, {
                  "auto-upload": true,
                  "show-file-list": false,
                  onClick: _cache[13] || (_cache[13] = $event => beforeUpload('sref')),
                  "http-request": uploadImg
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, {
                    class: "uploader-icon"
                  }, {
                    default: _withCtx(() => [_createVNode(_unref(UploadFilled))]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]), _createElementVNode("div", _hoisted_55, [_createVNode(_component_el_form_item, {
              label: "参考权重："
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_56, [_createVNode(_component_el_slider, {
                modelValue: params.value.cw,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => params.value.cw = $event),
                modelModifiers: {
                  number: true
                },
                max: 100,
                step: 1,
                style: {
                  "width": "180px"
                }
              }, null, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
                content: "取值范围 0-100 <br/>默认值100参考原图的脸部、头发和衣服<br/>0则表示只换脸",
                "raw-content": "",
                placement: "right"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                  _: 1
                })]),
                _: 1
              })])]),
              _: 1
            })]), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_cache[34] || (_cache[34] = _createElementVNode("span", null, "提示词：", -1)), _createVNode(_component_el_tooltip, {
              content: "输入你想要的内容，用逗号分割",
              placement: "right"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                _: 1
              })]),
              _: 1
            })])])]), _createElementVNode("div", _hoisted_61, [_createVNode(_component_el_input, {
              modelValue: params.value.prompt,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => params.value.prompt = $event),
              autosize: {
                minRows: 4,
                maxRows: 6
              },
              type: "textarea",
              ref_key: "promptRef",
              ref: promptRef,
              placeholder: "请在此输入绘画提示词，系统会自动翻译中文提示词，高手请直接输入英文提示词"
            }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_cache[35] || (_cache[35] = _createElementVNode("span", null, "不希望出现的内容：（可选）", -1)), _createVNode(_component_el_tooltip, {
              content: "不想出现在图片上的元素(例如：树，建筑)",
              placement: "right"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                _: 1
              })]),
              _: 1
            })])])]), _createElementVNode("div", _hoisted_65, [_createVNode(_component_el_input, {
              modelValue: params.value.neg_prompt,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => params.value.neg_prompt = $event),
              autosize: {
                minRows: 4,
                maxRows: 6
              },
              type: "textarea",
              ref_key: "promptRef",
              ref: promptRef,
              placeholder: "请在此输入你不希望出现在图片上的内容，系统会自动翻译中文提示词"
            }, null, 8, ["modelValue"])])])]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_row, {
          class: "text-info"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_text, {
            type: "primary"
          }, {
            default: _withCtx(() => [_cache[37] || (_cache[37] = _createTextVNode("每次绘图消耗 ")), _createVNode(_component_el_text, {
              type: "warning"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(mjPower.value) + "算力;", 1)]),
              _: 1
            }), _cache[38] || (_cache[38] = _createTextVNode("    U/V 操作消耗")), _createVNode(_component_el_text, {
              type: "warning"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(mjActionPower.value) + "算力;", 1)]),
              _: 1
            })]),
            _: 1
          }), _cache[40] || (_cache[40] = _createTextVNode("   ")), _createVNode(_component_el_text, {
            type: "primary"
          }, {
            default: _withCtx(() => [_cache[39] || (_cache[39] = _createTextVNode("当前可用算力：")), _createVNode(_component_el_text, {
              type: "warning"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(power.value), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createElementVNode("div", _hoisted_66, [_createVNode(_component_el_button, {
          type: "primary",
          dark: false,
          onClick: generate,
          round: ""
        }, {
          default: _withCtx(() => _cache[41] || (_cache[41] = [_createTextVNode("立即生成")])),
          _: 1
        })])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_67, [_cache[51] || (_cache[51] = _createElementVNode("h2", {
        class: "text-xl"
      }, "任务列表", -1)), _createVNode(TaskList, {
        list: runningJobs.value
      }, null, 8, ["list"]), finishedJobs.value.length > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_cache[50] || (_cache[50] = _createElementVNode("h2", {
        class: "text-xl"
      }, "创作记录", -1)), _createElementVNode("div", _hoisted_68, [finishedJobs.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_69, [_createVNode(_component_v3_waterfall, {
        id: "waterfall",
        list: finishedJobs.value,
        srcKey: "thumb_url",
        gap: 20,
        bottomGap: -8,
        colWidth: colWidth.value,
        distanceToScroll: 100,
        isLoading: loading.value,
        isOver: isOver.value,
        onScrollReachBottom: _cache[19] || (_cache[19] = $event => fetchFinishJobs())
      }, {
        default: _withCtx(slotProp => [_createElementVNode("div", _hoisted_70, [slotProp.item.img_url !== '' ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0,
          src: slotProp.item['thumb_url'],
          class: _normalizeClass(slotProp.item['can_opt'] ? '' : 'upscale'),
          onClick: $event => previewImg(slotProp.item),
          fit: "cover",
          "initial-index": slotProp.index,
          loading: "lazy"
        }, {
          placeholder: _withCtx(() => _cache[42] || (_cache[42] = [_createElementVNode("div", {
            class: "image-slot"
          }, "正在加载图片", -1)])),
          error: _withCtx(() => [_createElementVNode("div", _hoisted_71, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Picture))]),
            _: 1
          })])]),
          _: 2
        }, 1032, ["src", "class", "onClick", "initial-index"])) : slotProp.item.progress === 101 ? (_openBlock(), _createBlock(_component_el_image, {
          key: 1
        }, {
          error: _withCtx(() => [_createElementVNode("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, [_cache[45] || (_cache[45] = _createElementVNode("div", {
            class: "title"
          }, "任务失败", -1)), _createElementVNode("div", _hoisted_74, [_createVNode(_component_el_popover, {
            title: "错误详情",
            trigger: "click",
            width: 250,
            content: slotProp.item['err_msg'],
            placement: "top"
          }, {
            reference: _withCtx(() => [_createVNode(_component_el_button, {
              type: "info"
            }, {
              default: _withCtx(() => _cache[43] || (_cache[43] = [_createTextVNode("详情")])),
              _: 1
            })]),
            _: 2
          }, 1032, ["content"]), _createVNode(_component_el_button, {
            type: "danger",
            onClick: $event => removeImage(slotProp.item)
          }, {
            default: _withCtx(() => _cache[44] || (_cache[44] = [_createTextVNode("删除")])),
            _: 2
          }, 1032, ["onClick"])])])])]),
          _: 2
        }, 1024)) : (_openBlock(), _createBlock(_component_el_image, {
          key: 2
        }, {
          error: _withCtx(() => _cache[46] || (_cache[46] = [_createElementVNode("div", {
            class: "image-slot"
          }, [_createElementVNode("i", {
            class: "iconfont icon-loading"
          }), _createElementVNode("span", null, "正在下载图片")], -1)])),
          _: 1
        })), slotProp.item['can_opt'] ? (_openBlock(), _createElementBlock("div", _hoisted_75, [_createElementVNode("div", _hoisted_76, [_createElementVNode("ul", null, [_createElementVNode("li", null, [_createElementVNode("a", {
          onClick: $event => upscale(1, slotProp.item)
        }, "U1", 8, _hoisted_77)]), _createElementVNode("li", null, [_createElementVNode("a", {
          onClick: $event => upscale(2, slotProp.item)
        }, "U2", 8, _hoisted_78)]), _createElementVNode("li", null, [_createElementVNode("a", {
          onClick: $event => upscale(3, slotProp.item)
        }, "U3", 8, _hoisted_79)]), _createElementVNode("li", null, [_createElementVNode("a", {
          onClick: $event => upscale(4, slotProp.item)
        }, "U4", 8, _hoisted_80)]), _createElementVNode("li", _hoisted_81, [_createVNode(_component_el_popover, {
          placement: "left",
          title: "提示词",
          width: 240,
          trigger: "hover"
        }, {
          reference: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(ChromeFilled))]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_82, [_createElementVNode("span", null, _toDisplayString(slotProp.item.prompt), 1), _createVNode(_component_el_icon, {
            class: "copy-prompt-mj",
            "data-clipboard-text": slotProp.item.prompt
          }, {
            default: _withCtx(() => [_createVNode(_unref(DocumentCopy))]),
            _: 2
          }, 1032, ["data-clipboard-text"])])]),
          _: 2
        }, 1024)])])]), _createElementVNode("div", _hoisted_83, [_createElementVNode("ul", null, [_createElementVNode("li", null, [_createElementVNode("a", {
          onClick: $event => variation(1, slotProp.item)
        }, "V1", 8, _hoisted_84)]), _createElementVNode("li", null, [_createElementVNode("a", {
          onClick: $event => variation(2, slotProp.item)
        }, "V2", 8, _hoisted_85)]), _createElementVNode("li", null, [_createElementVNode("a", {
          onClick: $event => variation(3, slotProp.item)
        }, "V3", 8, _hoisted_86)]), _createElementVNode("li", null, [_createElementVNode("a", {
          onClick: $event => variation(4, slotProp.item)
        }, "V4", 8, _hoisted_87)])])])])) : _createCommentVNode("", true), slotProp.item.progress === 100 ? (_openBlock(), _createElementBlock("div", _hoisted_88, [_createVNode(_component_el_tooltip, {
          content: "删除任务",
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "danger",
            icon: _unref(Delete),
            onClick: $event => removeImage(slotProp.item),
            circle: ""
          }, null, 8, ["icon", "onClick"])]),
          _: 2
        }, 1024), slotProp.item.publish ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 0,
          content: "取消发布",
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "warning",
            onClick: $event => publishImage(slotProp.item, false),
            circle: ""
          }, {
            default: _withCtx(() => _cache[47] || (_cache[47] = [_createElementVNode("i", {
              class: "iconfont icon-cancel-share"
            }, null, -1)])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 2
        }, 1024)) : (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 1,
          content: "发布图片",
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "success",
            onClick: $event => publishImage(slotProp.item, true),
            circle: ""
          }, {
            default: _withCtx(() => _cache[48] || (_cache[48] = [_createElementVNode("i", {
              class: "iconfont icon-share-bold"
            }, null, -1)])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 2
        }, 1024)), _createVNode(_component_el_tooltip, {
          content: "复制提示词",
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "success",
            class: "copy-prompt-mj",
            "data-clipboard-text": slotProp.item.prompt,
            circle: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(DocumentCopy))]),
              _: 1
            })]),
            _: 2
          }, 1032, ["data-clipboard-text"])]),
          _: 2
        }, 1024)])) : _createCommentVNode("", true)])]),
        footer: _withCtx(() => _cache[49] || (_cache[49] = [_createElementVNode("div", {
          class: "no-more-data"
        }, [_createElementVNode("span", null, "没有更多数据了"), _createElementVNode("i", {
          class: "iconfont icon-face"
        })], -1)])),
        _: 1
      }, 8, ["list", "colWidth", "isLoading", "isOver"])])) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        "image-size": 100,
        image: _unref(nodata),
        description: "暂无记录"
      }, null, 8, ["image"]))])], 64)) : _createCommentVNode("", true)])], 4), _createVNode(BackTop, {
        right: 30,
        bottom: 30
      })])]), previewURL.value !== '' ? (_openBlock(), _createBlock(_component_el_image_viewer, {
        key: 0,
        onClose: _cache[20] || (_cache[20] = () => {
          previewURL.value = '';
        }),
        "url-list": [previewURL.value]
      }, null, 8, ["url-list"])) : _createCommentVNode("", true)]);
    };
  }
};